import { IReturnedCheckDtoCheckTypeEnum } from '@/dtos/models';

export enum CheckProcessingType {
  VOID = 'VOID',
  REISSUE = 'REISSUE',
}

export enum CheckVoidReason {
  NOT_RECEIVED = 'NOT_RECEIVED',
}

export interface ReturnedCheck {
  lockboxId: number;
  checkId?: number;
  checkType: IReturnedCheckDtoCheckTypeEnum;
  checkAmount: number;
  payTo?: string;
}

export interface CheckDecision {
  type: CheckProcessingType;
  paymentMethodId?: number;
}

export type CheckDecisions = Record<number, CheckDecision>;
